<template>
  <div class="tabs">
    <div
      class="tabs-container"
      :class="{
        'min-width': currentUser && currentUser.id
      }"
    >
      <div class="nav-tabs">
        <div
          v-tooltip="{
            content: 'Presentation',
            trigger: 'hover'
          }"
          class="nav-item"
          :class="{
            active: activeTabView === 'slide',
          }"
          :open-on-click="false"
          @click="handleSwitchTab(presentation.uniqueAccessCode ? 'Presentation' : 'home')"
        >
          <div class="nav-item-background" />
          <aha-icon
            class="nav-item-icon"
            :name="activeTabView === 'slide' ? 'presenter-solid' : 'presenter-light'"
          />
        </div>
        <div
          v-tooltip="{
            content: 'Review',
            trigger: 'hover'
          }"
          class="nav-item"
          :class="{
            active: activeTabView === 'lookback',
            disabled: isTabReviewDisabled,
          }"
          @click="handleSwitchTab('Lookback', isTabReviewDisabled)"
        >
          <div class="nav-item-background" />
          <aha-icon
            class="nav-item-icon"
            name="quiz-answer"
          />
        </div>
        <div
          v-if="isShowTabFeedback"
          v-tooltip="{
            content: 'Feedback',
            trigger: 'hover'
          }"
          class="nav-item"
          :class="{
            active: activeTabView === 'feedback',
            disabled: isTabFeedbackDisabled,
          }"
          @click="handleSwitchTab('Feedback', isTabFeedbackDisabled)"
        >
          <div class="nav-item-background" />
          <aha-icon
            class="nav-item-icon"
            :name="activeTabView === 'feedback' ? 'feedback-solid' : 'feedback'"
          />
        </div>
        <div
          v-if="isShowTabProfile"
          v-tooltip="{
            content: 'My Account',
            trigger: 'hover'
          }"
          class="nav-item nav-profile"
          :class="{
            active: activeTabView === 'profile',
          }"
          @click="handleSwitchTab(presentation.uniqueAccessCode ? 'Profile' : 'Account')"
        >
          <div class="nav-item-background" />
          <aha-icon
            class="nav-item-icon nav-item-icon__profile"
            :name="activeTabView === 'profile' ? 'profile-solid' : 'profile-light'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VTooltip from 'v-tooltip'
import Config from '@/config'
import Constant from '@/constant'
import EventBus from '@/eventBus'
import * as attendedPresentationUtil from '@/utils/attendedPresentation.util'
import util from '../util'

VTooltip.enabled = window.innerWidth > 768

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      activeTabView: (state) => state.activeTabView,
      presentation: (state) => state.presentation,
      audienceId: (state) => state.audienceId,
    }),
    isSkoleTube() {
      return this.presentation
        && this.presentation.user
        && this.presentation.user.identifyProvider === 'skoletube'
    },
    isTabReviewDisabled() {
      return !this.audienceId
    },
    isTabFeedbackDisabled() {
      return !this.audienceId
    },
    isShowTabFeedback() {
      return (this.presentation && this.presentation.isEnablePrivateFeedback) || this.isTabFeedbackDisabled
    },
    isShowTabProfile() {
      return !util.checkWhiteLabelDomain()
        && Config.region !== Constant.euRegion
        && !this.isSkoleTube
    },
    userId() {
      return this.currentUser && this.currentUser.id
    },
  },
  watch: {
    '$route.name': {
      handler(value) {
        this.handleRouteChange(value)
      },
      immediate: true,
    },
  },

  mounted() {
    // i want check, if url  ?tab=feedback => redirect to feedback tab
    const tab = util.getParamValue('tab')
    if (tab) {
      this.handleSwitchTab(tab)
    }

    EventBus.$on('changeTab', (targetTab) => {
      this.handleSwitchTab(targetTab)
    })
  },
  methods: {
    ...mapActions(['setActiveTabAction']),
    handleRouteChange(value) {
      const activeTab = this._getActiveTabByRouteName(value)

      let trackingProps = {}

      if (activeTab === 'lookback') {
        trackingProps = this.$route.query.fromAction === 'view_answers'
          ? {
            eventName: 'Leaderboard > View Answer',
            eventAction: 'View answers',
            eventLabel: 'Lookback',
            eventCategory: 'Audience',
            presentationId: this.presentation && this.presentation.id,
          }
          : {
            eventCategory: 'Audience',
            presentationId: this.presentation && this.presentation.id,
            value: this.$store.state.isMyQuizAnswersLoaded
              ? 'Has Quiz'
              : 'Empty',
          }
      }

      if (activeTab === 'profile') {
        const attendedPresentationsCount = attendedPresentationUtil.findAttendedPresentationsByUserId(this.userId).length
        trackingProps = {
          eventAction: 'Main screen > Switch tab',
          eventCategory: 'Audience',
          eventLabel: 'Account',
          attendedPresentationsCount,
        }
      }

      this.setActiveTabAction({ activeTab, trackingProps })
    },
    handleSwitchTab(routeName, isTabDisabled = false) {
      if (isTabDisabled) return

      this.$router.push({
        name: routeName,
        params: {
          id: this.$route.params.id,
        },
      })
    },
    _getActiveTabByRouteName(routeName) {
      switch (routeName) {
        case 'home':
        case 'Presentation':
          return 'slide'
        case 'Lookback':
          return 'lookback'
        case 'Feedback':
          return 'feedback'
        case 'Account':
        case 'Profile':
          return 'profile'
        default:
          return 'slide'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-container {
  width: 100%;
  background: #eff1f7;
}

.nav-tabs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(78px, 1fr));
  max-width: 710px;
  margin: 0 auto;
  color: #B4BCCF;

  .nav-item {
    padding: 14px;
    flex: auto;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #eff1f7;
    color: rgba(0, 0, 0, 0.2);

    &.active {
      background: #fff;
      color: #191F2D;
    }

    &.disabled {
      cursor: not-allowed;
      color: #B4BCCF;
    }
  }
}

.nav-item {
  &:not(.disabled) .nav-item-icon {
    color: #313131;
    fill: none;
  }

  .nav-item-icon__profile {
    color: #eff1f7;
  }
}

.nav-item.active {
  .nav-item-background {
    width: 32px;
    height: 32px;
    background: #DDECFF;
    border-radius: 50%;
    position: absolute;
  }

  .nav-item-icon {
    z-index: 1;
    color: #348EF6;
  }

  .nav-item-icon-profile {
    border: 2px solid #348EF6;
  }
}
</style>
